<app-main-page [navItems]="navigationItems">
</app-main-page>
